"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LICENSE_NAME = void 0;
var LICENSE_NAME;
(function (LICENSE_NAME) {
    LICENSE_NAME["AI_ASSIST_PRO"] = "ai_assist_pro";
    LICENSE_NAME["ANALYTICS_PLUS"] = "analytics_plus";
    LICENSE_NAME["AIRCALL_AI"] = "aircall_ai";
    LICENSE_NAME["WHATSAPP_MESSAGING"] = "whatsapp_messaging";
    LICENSE_NAME["SALESFORCE_SERVICE_CLOUD_VOICE"] = "salesforce_service_cloud_voice";
})(LICENSE_NAME || (exports.LICENSE_NAME = LICENSE_NAME = {}));
//# sourceMappingURL=extension.decl.js.map